<template>
  <div>
    <WrapperDocRef :title="$t('message.refdocs')">
      <template
        v-if="invoice.status == 'approved'"
        #content
      >
        <BaseSectionDocRefLink
          :title="`${$t('sidebar.paymententry')} (${invoice.reference.payments.length})`"
          :links="PELinks"
          :createButtonText="$t('newdocuments.pe')"
          :showCreateButton="(getDebtInvoiceAmount(invoice) > 0 || (getTotal(invoice.orders).net == 0) && invoice.reference.payments == 0) && !disabled"
          @onCreate="handleClickCreatePE"
        />
        <BaseSectionDocRefLink
          :title="`${$t('sidebar.receipt')} (${invoice.reference.receipts.length})`"
          :links="RTLinks"
          :createButtonText="$t('newdocuments.rt')"
          :showCreateButton="!disabled"
          @onCreate="handleClickCreateRT"
        />
      </template>
      <template
        v-else
        #content
      >
        -
      </template>
    </WrapperDocRef>

    <div
      id="registerpaymentModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="col row no-padding no-margin">
              <div class="col-6 no-padding">
                <h5 class="modal-title">{{ $t('sidebar.paymententry') }}</h5>
              </div>
              <div class="col-6 no-padding text-right">
                <template>
                  <h5
                    v-if="!nextPeCode"
                    class="modal-title">
                    <i
                      class="fas fa-spinner spin"
                      style="font-size: 15px; position: relative; top: -1px; }"/>
                  </h5>
                  <h5
                    v-else
                    class="modal-title">
                    {{ nextPeCode }}
                  </h5>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <template>
              <form-paymententry
                v-if="formPE_isReady"
                :in="invoice"
                :amount="getDebtInvoiceAmount(invoice)"
                :validation="trickValidationPayment"
                @submit="onSubmitPayment"/>
              <span v-else>
                {{ $t('message.loading') }}
              </span>
            </template>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeRegisterPaymentModal()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="!formPE_isReady"
              type="button"
              class="btn btn-web"
              @click="trickValidationPayment++">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="receiptModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg-90-percent"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="col row no-padding no-margin">
              <div class="col-6 no-padding">
                <h5 class="modal-title">{{ $t('sidebar.receipt') }}</h5>
              </div>
              <div class="col-6 no-padding text-right">
                <template>
                  <h5
                    v-if="!nextRtCode"
                    class="modal-title">
                    <i
                      class="fas fa-spinner spin"
                      style="font-size: 15px; position: relative; top: -1px; }"/>
                  </h5>
                  <h5
                    v-else
                    class="modal-title">
                    {{ nextRtCode }}
                  </h5>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <template>
              <form-receipt
                v-if="formRT_isReady"
                :inv="invoice"
                :validation="trickValidationRT"
                @submit="onSubmitReceipt"/>
            </template>
          </div>
          <div
            v-if="!$store.state.app.loading || !nextRtCode"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeReceiptModal()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="!formRT_isReady"
              type="button"
              class="btn btn-web"
              @click="trickValidationRT++">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading && nextRtCode"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WrapperDocRef from '@/components/combine/WrapperDocRef.vue'
import BaseSectionDocRefLink from '@/components/base/BaseSectionDocRefLink.vue'
import _ from 'lodash'
import FormReceipt from '../../../../custom/FormReceipt.vue'

export default {
  props: {
    invoice: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      loadingBtnCreatePE: false,

      trickValidationPayment: 0,
      trickValidationRT: 0,

      showFormPE: false,
      showFormRT: false,
    }
  },
  components: {
    WrapperDocRef,
    BaseSectionDocRefLink,
    FormReceipt,
  },
  computed: {
    ...mapGetters({
      loading: 'getLoading',
      error: 'getError',
      nextPeCode: 'getNextPeCode',
      getPaymentStatus: 'getPaymentStatus',
      getSaleStatus: 'getSaleStatus',
      getInvoiceStatus: 'getInvoiceStatus',
      nextRtCode: 'getNextRtCode',
    }),
    PELinks() {
      return this.invoice.reference.payments.map((item) => {
        return {
          to: {
            name: 'AccountsPaymentEntryEdit',
            query: {
              pe_id: item.pe_id,
              pe_code: item.pe_code,
            },
          },
          text: item.pe_code,
          status: {
            text: this.getPaymentStatus(item, this.$t).message,
            color: this.getColorFormStatus(this.getPaymentStatus(item, this.$t).status),
            type: 'icon',
          },
          to_appid: 12,
          current_appid: 4,
        }
      })
    },
    formPE_isReady () {
      return this.showFormPE
    },
    RTLinks() {
      return this.invoice.reference.receipts.map((item) => {
        return {
          to: {
            name: 'AccountsReceiptEdit',
            query: {
              rt_id: item.rt_id,
              rt_code: item.rt_code,
            },
          },
          text: item.rt_code,
          to_appid: 12,
          current_appid: 12,
        }
      })
    },
    formRT_isReady () {
      return this.showFormRT
    },
  },
  methods: {
    ...mapActions([
      'getInvoice',
      'insertPayment',
      'insertReceipt',
      'getNextPeCode',
      'getNextRtCode',
    ]),
    async openRegisterPaymentModal () {
      // set status form
      this.showFormPE = true
      // show modal
      $('#registerpaymentModal').modal('show')
      // get next pe code
      if (!this.nextPeCode) {
        await this.getNextPeCode()
        // finish bar loading
        this.showFinish(this.$Progress)
      }
    },
    closeRegisterPaymentModal () {
      // set status form
      this.showFormPE = false
      // show modal
      $('#registerpaymentModal').modal('hide')
    },
    async onSubmitPayment (isValid, data) {
      if (!isValid) {
        return false
      }

      let dataSet = {
        'type': 'receive',
        'status': data.status,
        'created_at': this.moment().toISOString(),
        'note': data.note,
        'payment': {
          	'type': data.type,
          	'amount': parseFloat(data.amount),
        },
        'reference': {
          'in_id': this.invoice.in_id,
        },
        'partner': {
          'customer_id': data.partner.customer_id ? data.partner.customer_id : null,
        },
      }

      let res = await this.$store.dispatch('insertPayment', dataSet)

      if (res.success) {
        var MILLISEC = 500
        var delay = 0

        // call api to get invoice
        await this.$store.dispatch('getInvoice', { in_id: this.invoice.in_id })

        let newPayment = res.data.payment

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newPayment.pe_code }),
          color: 'success',
          icon: 'cloud',
        })

        // show notify invoice completed
        if (this.getInvoiceStatus(this.invoice, this.$t, this.mixin).status == 'completed') {
          let that = this
          setTimeout(() => {
            that.notify(that.$vs, {
              text: that.$t('message.hasbeencompleted', { msg: that.invoice.in_code }),
              color: 'success ',
              icon: 'check',
            })
          }, delay += MILLISEC)
        }

        // this invoice have reference sale order
        if (this.invoice.reference.sale) {
          let res = await this.$store.dispatch('getSale', {
            so_id: this.invoice.reference.sale.so_id,
          })
          if (res.success && res.data.length > 0) {
            let sale = res.data[0]
            if (this.getSaleStatus(sale, this.$t, this.mixin).status == 'completed') {
              let that = this
              // show notify
              setTimeout(() => {
                that.notify(that.$vs, {
                  text: that.$t('message.hasbeencompleted', { msg: this.invoice.reference.sale.so_code }),
                  color: 'success ',
                  icon: 'check',
                })
              }, delay += MILLISEC)
            }
          }
        }

        // finish loading
        this.closeRegisterPaymentModal()
        this.showFinish(this.$Progress)
      }
    },
    handleClickCreatePE() {
      this.openRegisterPaymentModal()
    },
    handleClickCreateRT() {
      this.openReceiptModal()
    },
    async openReceiptModal () {
      // set status form
      this.showFormRT = true
      // show modal
      $('#receiptModal').modal('show')
      // get next pe code
      if (!this.nextRtCode) {
        await this.getNextRtCode()
        // finish bar loading
        this.showFinish(this.$Progress)
      }
    },
    closeReceiptModal () {
      // set status form
      this.showFormRT = false
      // show modal
      $('#receiptModal').modal('hide')
    },
    getDataSetOrders (orders) {
      const data = _.cloneDeep(orders)
      const newData = []
      // remove key, data we don't need
      for (const i in data) {
        const item = data[i]
        if (item.sku_id) {
          newData.push({
            item: item.item,
            description: item.description,
            sku_id: item.sku_id,
            quantity: parseFloat(item.quantity) || 0,
            price: parseFloat(item.price) || 0,
            discounts: item.discounts.map((discount) => ({
              ...discount,
              type: 'general',
              value_amount: parseFloat(discount.value_amount),
            })),
            taxes: item.taxes.map((tax) => ({
              name: tax.tax_name,
              type: tax.type,
              amount: tax.amount,
              form_type: tax.form_type,
              group_name: tax.group_name,
              is_display_fee_result: tax.is_display_fee_result,
              is_for_sale: tax.is_for_sale,
              is_for_purchase: tax.is_for_purchase,
              fee: tax.fee ? tax.fee : null,
              tax_id: tax.tax_id,
            })),
          })
        }
      }
      return newData
    },
    async onSubmitReceipt (isValid, data) {
      if (!isValid) {
        return false
      }

      let creditType = 'cash'
      let creditDays = 0

      if (data.selectedCredit == 'custom') {
        creditType = 'days'
        creditDays = data.inputCustomCreditDay
      } else if (data.selectedCredit.search('days.') >= 0) {
        let arr = data.selectedCredit.split('.')
        let days = arr[1]
        creditType = 'days'
        creditDays = days
      }

      const orders = this.getDataSetOrders(data.orders)
      const dataSet = {
        'orders': orders,
        'customer_id': this.invoice.customer ? this.invoice.customer.customer_id : null,
        'status': data.approved ? 'approved' : 'padding',
        'created_at': data.created_at.toISOString(),
        'credit': {
          	'type': creditType,
          	'days': parseInt(creditDays),
        },
        'scheduled_at': data.scheduled_at.toISOString(),
        'note': data.note,
        'in_id': this.invoice.in_id,
        'paid_amount': Number(data.paid_amount),
        'paid_at': data.paid_at.toISOString(),
        'payment_method': data.payment_method,
      }

      const res = await this.insertReceipt(dataSet)

      if (res.success) {
        const newReceipt = res.data.receipt

        await this.getInvoice({ in_id: this.invoice.in_id })

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newReceipt.rt_code }),
          color: 'success',
          icon: 'cloud',
        })

        // finish loading
        this.showFinish(this.$Progress)
        this.closeReceiptModal()
      }
    },
  },
  created: async function () {

  },
  mounted: function () {
    // set popup modal
    this.setModal('#registerpaymentModal')
    this.setModal('#receiptModal')
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/invoice/include/RefINV.vue